import { Signal } from "@lit-labs/signals";
import type { BrandsSearchResult } from "api-contracts/rpc/brands-search";
import type { IBackofficeBrandsState } from "./types";

export class BackofficeBrandsState implements IBackofficeBrandsState {
  readonly brands = new Signal.State<BrandsSearchResult | null>(null);
  readonly loading = new Signal.State<boolean>(false);
}
